import styled from '@emotion/styled';
import { DndColumns } from '../../dialogs/LayoutComponentWizard/subsections/RelatedObjectFields/DnDColumns';

export const StyledDnDColumns = styled(DndColumns)`
  min-height: calc(100vh - 352px);
`;
